// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { Comment, PostType } from "../../dashboard/src/interfaces";
import { getToken } from "../../../components/src/AuthService";
import React from "react";
import { Color } from "@material-ui/lab/Alert";
import { WithWidthProps } from "@material-ui/core";
const helper = require("../../../components/src/helper.js");
export const configJSON = require("./config");

export enum CommentOrderEnum {
  ASCENDING = "asc",
  DESCENDING = "desc",
}

interface ILikePayload {
  like: {
    likeable_id: string;
    likeable_type: string;
  };
}

interface IPostPayload {
  postId: string;
  commentId: string;
}

export interface Props extends WithWidthProps {
  navigation: any;
  id: string;
  classes?: any;
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

interface S {
  token: any;
  setToken: string;
  isLoading: boolean;
  isShowAlert: boolean;
  showSuccess: string;
  comment: string;
  commentImage: File | null
  isAddingComment: boolean;
  postPayload: IPostPayload | null;
  postData: PostType | null;
  isHighlightComment: boolean;
  repliesOpenCommentId: string;
  replyingToId: string;
  replyingToName: string;
  commentsOrder: CommentOrderEnum;
  isSortingComments: boolean;
  postComments: Comment[];
  infoType: 'success' | 'error' | 'info' | 'warning';
  isAllCommentClicked: boolean
  commentOptionsModal: boolean
  commentOptionsAnchorEl: HTMLElement | null
  videoCommentModal: boolean
  selectedVideoFile: File | null
  showMobileVideoSource: boolean
  pollCommentModal: boolean
  pollQuestion: string
  pollOptions: string[]
  allowMultipleResponses: boolean
}

interface SS {
  id: any;
}

export default class OpenNotificationController extends BlockComponent<
  Props,
  S,
  SS
> {
  highlightTimer: NodeJS.Timeout | null = null;
  commentFieldRef: React.RefObject<HTMLInputElement> = React.createRef();
  imageCommentFieldRef: React.RefObject<HTMLInputElement> = React.createRef();
  commentsWrapperRef: React.RefObject<HTMLDivElement> = React.createRef();
  videoCommentRef: React.RefObject<HTMLInputElement> = React.createRef();
  videoModalInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  videoGalleryInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  videoCameraInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  postCommentCallId: string = "";
  postPollNotificationCallId: string = "";
  deletePollNotificationCallId: string = "";
  getPostDataApiCallId: string = "";
  getCommentsApiCallId: string = "";
  likeApiCallId: string = "";
  undoLikeApiCallId: string = "";

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
    ];

    this.state = {
      token: "",
      setToken: "",
      isShowAlert: false,
      isLoading: false,
      showSuccess: "",
      comment: "",
      commentImage: null,
      isAddingComment: false,
      postPayload: null,
      postData: null,
      isHighlightComment: false,
      repliesOpenCommentId: "",
      replyingToId: "",
      replyingToName: "",
      commentsOrder: CommentOrderEnum.ASCENDING,
      isSortingComments: false,
      postComments: [],
      infoType: "success",
      isAllCommentClicked: false,
      commentOptionsModal: false,
      commentOptionsAnchorEl: null,
      videoCommentModal: false,
      selectedVideoFile: null,
      showMobileVideoSource: false,
      pollCommentModal: false,
      pollQuestion: "",
      pollOptions: ["", ""],
      allowMultipleResponses: true,
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    this.handleGetPostData();
  }

  async componentDidUpdate(
    _prevProps: Readonly<Props>,
    prevState: Readonly<S>
  ): Promise<void> {
    const { postPayload, postData, commentsOrder } = this.state;
    if (prevState.postPayload?.postId !== postPayload?.postId) {
      this.handleGetPostData();
    }

    if (prevState.postData?.id !== postData?.id) {
      this.handleCommentHighlight();
    }

    if(prevState.commentsOrder !== commentsOrder && postData) {
      this.setState({ isSortingComments: true })
      this.getPostCommentsApiCall(postData.id)
    }
  }

  async componentWillUnmount(): Promise<void> {
    if (this.highlightTimer) {
      clearTimeout(this.highlightTimer);
    }
  }

  toggleCommentSortChange = () => {
    const updatedOrder =
      this.state.commentsOrder === CommentOrderEnum.ASCENDING
        ? CommentOrderEnum.DESCENDING
        : CommentOrderEnum.ASCENDING;
    this.setState({ commentsOrder: updatedOrder });
  };

  showSnackbar = (severity: 'success' | 'error' | 'info' | 'warning' = 'success', message: string) => {
    this.setState({
      isShowAlert: true,
      showSuccess: message,
      infoType: severity
    });
  };

  handleCloseSnackbar = () => {
    this.setState({ isShowAlert: false });
  };

  handleCloseCommentOptionsModal = () => {
    this.setState({ commentOptionsModal: false, commentOptionsAnchorEl: null })
  }

  handleUploadVideoComment = (event?: React.MouseEvent | React.TouchEvent) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.setState({
      commentOptionsModal: false,
      commentOptionsAnchorEl: null,
      videoCommentModal: true,
      selectedVideoFile: null,
      showMobileVideoSource: false
    })
  }

  handleCloseVideoCommentModal = () => {
    this.setState({
      videoCommentModal: false,
      selectedVideoFile: null,
      showMobileVideoSource: false
    })
    // Reset all video inputs
    if (this.videoModalInputRef.current) this.videoModalInputRef.current.value = ''
    if (this.videoGalleryInputRef.current) this.videoGalleryInputRef.current.value = ''
    if (this.videoCameraInputRef.current) this.videoCameraInputRef.current.value = ''
    // Note: Don't clear comment state here as it might be used for regular comments
    // Only clear it after successful upload
  }

  handleSelectVideo = () => {
    // Directly open file picker on both mobile and desktop
    if (this.videoModalInputRef.current) {
      this.videoModalInputRef.current.value = ''
      this.videoModalInputRef.current.click()
    }
  }
  handleVideoCommentUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files: videoFiles } = event.currentTarget;
    if (videoFiles && videoFiles.length > 0) {
      const currentFile = videoFiles[0];

      // Validate file type - only allow video files
      const validVideoTypes = [
        'video/mp4',
        'video/mpeg',
        'video/quicktime',
        'video/x-msvideo',
        'video/x-matroska',
        'video/webm',
        'video/3gpp',
        'video/x-flv'
      ];

      // Also check file extension as fallback
      const validExtensions = ['.mp4', '.mpeg', '.mov', '.avi', '.mkv', '.webm', '.3gp', '.flv'];
      const fileExtension = currentFile.name.toLowerCase().substring(currentFile.name.lastIndexOf('.'));

      const isValidVideoType = validVideoTypes.includes(currentFile.type) ||
        validExtensions.includes(fileExtension) ||
        currentFile.type.startsWith('video/');

      if (isValidVideoType) {
        // Store the selected video file
        this.setState({ selectedVideoFile: currentFile })
        this.showSnackbar("success", "Video selected: " + currentFile.name)
        // Don't close modal yet - user can review and confirm
      } else {
        this.showSnackbar("error", "Invalid file type. Please select a video file only (MP4, MOV, AVI, etc.)")
        // Reset input on error
        if (this.videoModalInputRef.current) this.videoModalInputRef.current.value = ''
        if (this.videoCommentRef.current) this.videoCommentRef.current.value = ''
        if (this.videoGalleryInputRef.current) this.videoGalleryInputRef.current.value = ''
        if (this.videoCameraInputRef.current) this.videoCameraInputRef.current.value = ''
      }
    }
  }

  handleAddPollComment = (event?: React.MouseEvent | React.TouchEvent) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.setState({
      commentOptionsModal: false,
      commentOptionsAnchorEl: null,
      pollCommentModal: true
    })
  }

  handleClosePollCommentModal = () => {
    this.setState({
      pollCommentModal: false,
      pollQuestion: "",
      pollOptions: ["", ""],
      allowMultipleResponses: true
    })
  }

  handlePollOptionChange = (index: number, value: string) => {
    const newOptions = [...this.state.pollOptions]
    newOptions[index] = value
    this.setState({ pollOptions: newOptions })
  }

  handlePollContinue = async (event?: React.MouseEvent | React.TouchEvent) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (!this.state.pollQuestion.trim()) {
      this.showSnackbar("error", "Please enter a question")
      return
    }
    const validOptions = this.state.pollOptions.filter(opt => opt.trim() !== "")
    if (validOptions.length < 2) {
      this.showSnackbar("error", "Please add at least 2 options")
      return
    }
    if (!this.state.postData || !this.state.postData?.id) {
      this.showSnackbar("error", "No post selected")
      return
    }

    try {
      let payload: any = {
        "comment": {
          "comment": "Poll",
          "commentable_id": this.state.postData?.id,
          "commentable_type": "BxBlockPosts::Post",
          "comment_poll_attributes": {
            "question": this.state.pollQuestion.trim(),
            "comment_poll_options_attributes": validOptions.map((item: string) => ({
              name: item.trim()
            }))
          }
        }
      }
      this.postPollApiCall(payload);
      this.handleClosePollCommentModal();
    } catch (error: any) {
      console.error("Error creating poll:", error);
      this.showSnackbar("error", "An error occurred while creating the poll. Please try again.")
    }
  }

  handleConfirmVideoUpload = () => {
    if (this.state.selectedVideoFile) {
      const formData = new FormData();
      
      // Handle reply vs top-level comment
      if (this.state.replyingToId) {
        // This is a reply to a comment
        formData.append("comment[commentable_id]", this.state.replyingToId);
        formData.append("comment[commentable_type]", "BxBlockComments::Comment");
      } else {
        // This is a top-level comment
        formData.append("comment[commentable_type]", "BxBlockPosts::Post");
        formData.append("comment[commentable_id]", this.state.postData?.id?.toString() || "");
      }
      
      // Append comment text (use comment from state, or empty string if not provided)
      formData.append("comment[comment]", this.state.comment || "");
      
      // Append video file - ensure it's added correctly
      formData.append("comment[files][]", this.state.selectedVideoFile);
      
      // Call the API to upload video comment
      this.postCommentApi(formData);
      
      this.setState({
        selectedVideoFile: null,
        comment: "",
        videoCommentModal: false
      })
    } else {
      this.showSnackbar("error", "Please select a video file first");
    }
  }

  postPollApiCall = (payload: any) => {
    const msg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.postPollNotificationCallId = msg.messageId;

    msg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.postCommentEndPoint
    );

    msg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        "Content-Type": "application/json",
        token: localStorage.getItem(configJSON.AUTH_TOKEN),
      })
    );

    msg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    msg.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(payload)
    );

    runEngine.sendMessage(msg.id, msg);
  };

  handlePollVoteNotification = (optionId: number, postId: string) => {
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));

    this.postPollNotificationCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getPostDataEndPoint + `/${postId}/vote?option_id=${optionId}`
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: localStorage.getItem(configJSON.AUTH_TOKEN),
      })
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  }

  handlePollDeleteNotification = (optionId: number, postId: string) => {
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));

    this.deletePollNotificationCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getPostDataEndPoint + `/${postId}/delete_vote?option_id=${optionId}`
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: localStorage.getItem(configJSON.AUTH_TOKEN),
      })
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "DELETE"
    );

    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  }

  handleCommentPollVote = (optionId: number, commentId: string) => {
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));

    this.postPollNotificationCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.postCommentEndPoint + `/${commentId}/vote?option_id=${optionId}`
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: localStorage.getItem(configJSON.AUTH_TOKEN),
      })
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  }

  handleCommentPollDeleteVote = (optionId: number, commentId: string) => {
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));

    this.deletePollNotificationCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.postCommentEndPoint + `/${commentId}/delete_vote?option_id=${optionId}`
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: localStorage.getItem(configJSON.AUTH_TOKEN),
      })
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "DELETE"
    );

    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  }

  getFieldPlaceholder = () => {
    const { replyingToName } = this.state;
  
    if (replyingToName) {
      const shortName =
        replyingToName.length > 12
          ? replyingToName.substring(0, 12) + "..."
          : replyingToName;
  
      return `Replying to ${shortName}`;
    }
  
    return "Add a comment";
  };
  

  handleReplyClick = (commentDetails: Comment, commentId?: string) => {
    const {
      id,
      attributes: {
        account: {
          data: {
            attributes: { first_name, last_name },
          },
        },
      },
    } = commentDetails;
    this.setState({
      replyingToId: commentId || id,
      replyingToName: `${first_name} ${last_name}`,
    });
    if (this.commentFieldRef.current) {
      this.commentFieldRef.current.focus();
    }
  };

  handleCommentFieldBlur = () => {
    !this.state.comment &&
      this.setState({ replyingToId: "", replyingToName: "" });
  };

  ternary = <T, U>(condition: boolean, param1: T, param2: U) => {
    return condition ? param1 : param2;
  };

  orCondition = <T, U>(param1: T, param2: U) => {
    return param1 || param2;
  };

  getReplyText = (repliesLength: number) => {
    const repliesNumber = helper.numberToCount(repliesLength);
    return repliesLength > 1
      ? `View ${repliesNumber} replies`
      : `View ${repliesNumber} reply`;
  };

  toggleReplies = (commentId: string) => {
    const updatedId =
      this.state.repliesOpenCommentId === commentId ? "" : commentId;
    this.setState({ repliesOpenCommentId: updatedId });
  };

  handleGetPostData = () => {
    const { postPayload } = this.state;
    if (postPayload) {
      const { postId } = postPayload;
      this.getPostDataApi(postId);
    } else {
      const storagePayload = localStorage.getItem(
        configJSON.SinglePostPayloadKey
      );
      if (storagePayload) {
        this.setState({ postPayload: JSON.parse(storagePayload) });
      }
    }
  };

  handleCommentHighlight = () => {
    const { postPayload } = this.state;
    if (postPayload) {
      const { commentId } = postPayload;
      this.highlightComment(commentId, true)
    }
  };

  highlightComment = (commentId: string, isHighlight?: boolean) => {
    const hightComment = document.getElementById(`comment-${commentId}`);
    if (hightComment) {
      hightComment.scrollIntoView({
        behavior: "smooth",
      });
      if(isHighlight) {
        this.setState({ isHighlightComment: true });
        this.highlightTimer = setTimeout(() => {
          this.setState({ isHighlightComment: false });
        }, 4000);
      }
    }
  }

  handleCommentsWrapperInView = () => {
    if(this.commentsWrapperRef.current) {
      this.commentsWrapperRef.current.scrollIntoView({
        block: "start",
        behavior: "smooth"
      })
    }
  }

  isToHighlight = (commentId: string) => {
    const { postPayload, isHighlightComment } = this.state;
    if (postPayload) {
      return postPayload.commentId === commentId && isHighlightComment;
    }
    return false;
  };

  async receive(_from: string, message: Message) {
    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      const data = message.getData(
        getName(MessageEnum.NotificationToPostPayloadMessage)
      );
      this.setState({ postPayload: data, isAllCommentClicked: !data.commentId });
      localStorage.setItem(
        configJSON.SinglePostPayloadKey,
        JSON.stringify(data)
      );
    }

    const messageType = getName(MessageEnum.RestAPIResponceMessage);
    if (messageType === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );
      if (responseJson && !responseJson.error && !responseJson.errors) {
        this.handleApiSuccessResponse(apiRequestCallId, responseJson);
      } else {
        this.handleApiErrorResponse(apiRequestCallId, responseJson);
      }
    }
  }

  isShowCell = () => {
    setTimeout(() => this.setState({ isShowAlert: false, showSuccess: "", infoType: "success"  }), 3000);
  };

  handleRedirection = (pageName: string) => {
    const msg = new Message(getName(MessageEnum.NavigationMessage));
    msg.addData(getName(MessageEnum.NavigationTargetMessage), pageName);
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  };

  handleImageCommentClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ commentOptionsAnchorEl: event.currentTarget, commentOptionsModal: true })
  }

  // handleImageCommentClick = () => {
  //   if(this.imageCommentFieldRef.current) {
  //     this.imageCommentFieldRef.current.click()
  //   }
  // }

  handleImageCommentRemove = () => {
    this.setState({ commentImage: null })
  }

  handleImageCommentUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files: imageFiles } = event.currentTarget;
    if (imageFiles && imageFiles.length > 0) {
      const currentFile = imageFiles[0];
      
      const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      
      if (validImageTypes.includes(currentFile.type)) {
        this.setState({commentImage: currentFile })
      } else {
        this.setState({
          isShowAlert: true,
          infoType: "error",
          showSuccess: "Invalid file type. Please upload a jpeg, jpg, or png image.",
        })
        this.isShowCell()
      }
    }
  }

  handlePostComment = () => {
    const { postData, replyingToId } = this.state;
    if (replyingToId) {
      this.initiateComment(replyingToId, configJSON.CommentClass);
    } else if (postData) {
      this.initiateComment(postData.id, configJSON.PostClass);
    }
  };

  initiateComment = (commentableId: string, commentType: string) => {
    const { comment, commentImage } = this.state;
    const formData = new FormData();
    formData.append("comment[commentable_id]", commentableId);
    formData.append("comment[comment]", comment);
    formData.append("comment[commentable_type]", commentType);
    commentImage && formData.append("comment[files][]", commentImage);
    this.postCommentApi(formData);
  };

  postCommentApi = (formData: FormData) => {
    this.setState({ isAddingComment: true });
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));

    this.postCommentCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: localStorage.getItem(configJSON.AUTH_TOKEN),
      })
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.postCommentEndPoint
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      formData
    );

    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getPostDataApi = (postId: string) => {
    this.setState({ isLoading: true });
    const endPoint = `${configJSON.getPostDataEndPoint}/${postId}`;
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));

    this.getPostDataApiCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endPoint
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify({
        token: getToken(),
      })
    );

    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getDataMethod
    );

    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getPostCommentsApiCall = (postId: string) => {
    const header = {
      "Content-Type": configJSON.apiContentType,
      token: getToken(),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getCommentsApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.postCommentEndPoint}?commentable_id=${postId}&commentable_type=${configJSON.PostClass}&sort=${this.state.commentsOrder}`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getDataMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handlePostLikeUnlike = () => {
    const { postData } = this.state;
    if (postData) {
      const {
        id,
        type,
        attributes,
        attributes: { is_liked, likes_count },
      } = postData;
      const updatedCount = is_liked ? likes_count - 1 : likes_count + 1;
      const updatedPost = {
        id,
        type,
        attributes: {
          ...attributes,
          is_liked: !is_liked,
          likes_count: updatedCount,
        },
      };
      this.setState({ postData: updatedPost });
      is_liked
        ? this.undoLikeApiCall(id, configJSON.PostClass)
        : this.handleLike(id, configJSON.PostClass);
    }
  };

  handleCommentLikeUnlike = (commentId: string, isLiked: boolean) => {
    const { postComments } = this.state;
      const updatedComments = [...postComments].map((commentData) => {
        const { id, type, attributes } = commentData;
        if (id === commentId) {
          return {
            id,
            type,
            attributes: {
              ...attributes,
              already_liked: !isLiked,
            },
          };
        }
        return commentData;
      });
      this.setState({ postComments: updatedComments });
      isLiked
        ? this.undoLikeApiCall(commentId, configJSON.CommentClass)
        : this.handleLike(commentId, configJSON.CommentClass);
  };

  handleCommentReplyLikeUnlike = (
    commentId: string,
    commentReplyId: string,
    isLiked: boolean
  ) => {
    const { postComments } = this.state;
      const updatedComments = [...postComments].map((commentData) => {
        const {
          id,
          type,
          attributes,
          attributes: { replies },
        } = commentData;
        if (id === commentId) {
          const updatedReplies = [...replies.data].map((replyData) => {
            const { attributes, ...rest } = replyData;
            if (replyData.id === commentReplyId) {
              return {
                ...rest,
                attributes: {
                  ...attributes,
                  already_liked: !isLiked,
                },
              };
            }
            return replyData;
          });
          return {
            id,
            type,
            attributes: {
              ...attributes,
              replies: {
                data: updatedReplies,
              },
            },
          };
        }
        return commentData;
      });
      this.setState({ postComments: updatedComments });
      isLiked
        ? this.undoLikeApiCall(commentReplyId, configJSON.CommentClass)
        : this.handleLike(commentReplyId, configJSON.CommentClass);
  };

  handleLike = (likeableId: string, type: string) => {
    const payload = {
      like: {
        likeable_id: likeableId,
        likeable_type: type,
      },
    };
    this.likeApiCall(payload);
  };

  likeApiCall = (httpBody: ILikePayload) => {
    const header = {
      "Content-Type": configJSON.apiContentType,
      token: getToken(),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.likeApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.likeApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  undoLikeApiCall = (likeableId: string, likeType: string) => {
    const endPoint = `${configJSON.undoLikeApiEndpoint}?likeable_id=${likeableId}&likeable_type=${likeType}`;
    const header = {
      "Content-Type": configJSON.apiContentType,
      token: getToken(),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.undoLikeApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.deleteMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  postCommentApiResponse = (responseJson: any) => {
    if (responseJson) {
      const { replyingToId, postComments, postData } = this.state;
      let updatedComments = [...postComments];

      if (replyingToId) {
        // Find the parent comment and update its replies
        const updateCommentReplies = (comments: any[]): any[] => {
          return comments.map(comment => {
            const commentId = comment.id || (comment.attributes && comment.attributes.id);

            // If this is the parent comment
            if (commentId == replyingToId) {  // Use loose equality to handle string/number IDs
              const currentReplies = comment.attributes?.replies?.data || [];
              return {
                ...comment,
                attributes: {
                  ...comment.attributes,
                  replies: {
                    ...(comment.attributes?.replies || {}),
                    data: [
                      ...currentReplies,
                      responseJson.data
                    ]
                  }
                }
              };
            }

            // If this comment has replies, recursively check them
            if (comment.attributes?.replies?.data?.length) {
              return {
                ...comment,
                attributes: {
                  ...comment.attributes,
                  replies: {
                    ...comment.attributes.replies,
                    data: updateCommentReplies(comment.attributes.replies.data)
                  }
                }
              };
            }

            return comment;
          });
        };

        updatedComments = updateCommentReplies(updatedComments);
      } else {
        // If it's a top-level comment
        updatedComments = [responseJson.data, ...postComments];
      }

      this.setState(
        {
          isShowAlert: true,
          showSuccess: responseJson.meta.message,
          postComments: updatedComments,
          isAddingComment: false,
          comment: "",
          commentImage: null,
          replyingToId: "",
          replyingToName: "",
        },
        () => {
          this.isShowCell();
          const newCommentId = responseJson.data?.id ||
            (responseJson.data?.attributes && responseJson.data.attributes.id);
          if (newCommentId) {
            this.highlightComment(newCommentId);
          }
        }
      );
      this.handleCommentFieldBlur();
    }
  };

  showAllComments = () => {
    const { postData } = this.state
    if(postData) {
      this.setState({ isAllCommentClicked: true })
      this.getPostCommentsApiCall(postData.id)
    }
  }

  handleCommentsApiResponse = (responseJson: { data: Comment[] }) => {
    const { isAllCommentClicked, postPayload } = this.state
    let comments = responseJson.data
    if(!isAllCommentClicked && postPayload) {
      const { commentId } = postPayload
      comments = responseJson.data.filter((commentData: Comment) => commentData.id === commentId)
    }
    this.setState({ postComments: comments, isSortingComments: false }, () => this.handleCommentsWrapperInView())
  }

  handlePostDataApiResponse = (responseJson: any) => {
    const { isAllCommentClicked, postPayload } = this.state
    const {
      data,
      data: {
        attributes: {
          comments: { data: comments },
        },
      },
    } = responseJson;
    let showComments = comments
    if(!isAllCommentClicked && postPayload) {
      const { commentId } = postPayload
      showComments = comments.filter((commentData: Comment) => commentData.id === commentId)
    }
    this.setState({
      postData: data,
      postComments: showComments,
      isLoading: false,
    }, () => {
      if(postPayload?.commentId) {
        const selectedComment = comments.find((comment: Comment) => comment.id === postPayload.commentId)
        if(selectedComment) {
          const {
            id,
            attributes: {
              account: {
                data: {
                  attributes: { first_name, last_name },
                },
              },
            },
          } = selectedComment;
          this.setState({
            replyingToId: id,
            replyingToName: `${first_name} ${last_name}`,
          });
        }
        this.handleCommentsWrapperInView()
      }
    });
  }

  handleApiSuccessResponse = (apiRequestCallId: string, responseJson: any) => {
    switch (apiRequestCallId) {
      case this.postCommentCallId:
        this.postCommentApiResponse(responseJson);
        break;
      case this.getPostDataApiCallId:
        this.handlePostDataApiResponse(responseJson)
        break;
      case this.getCommentsApiCallId:
        this.handleCommentsApiResponse(responseJson)
        break;
      case this.postPollNotificationCallId:
        this.getPostCommentsApiCall(this.state.postData?.id || "");
        this.handleClosePollCommentModal();
        this.handleCommentFieldBlur();
        break;
    }
  };

  handleApiErrorResponse = (apiRequestCallId: string, _responseJson: any) => {
    if (apiRequestCallId === this.getPostDataApiCallId) {
      this.handleRedirection("Notifications");
    }
  };
}
// Customizable Area End
